<script setup>
import {BriefcaseIcon, HeartIcon, RssIcon, UserGroupIcon} from "@heroicons/vue/16/solid";
  import {useAuthStore} from "@/stores/auth";
import {useMiscStore} from "@/stores/misc";

  const props = defineProps({
    user: {
      default: null,
      type: Object
    }
  }),
      miscStore =  useMiscStore(),
      toggleFollowing = (id) => {
        if (useAuthStore().guest) {
          return alert('You need to be logged in to perform this action');
        }
      miscStore.toggleFollowing(id).then(() => {
        if (miscStore.error) {
          return alert(miscStore.error);
        }
      })
    };
</script>

<template>
  <div class="p-2 bg-white min-h-[420px] rounded-lg mb-2 shadow-md">
    <div
      class="relative overflow-hidden min-h-[420px] rounded-xl shadow-inner flex"
      :style="[
        'background-image: url(\'' + props.user?.profile?.avatar + '\');' +
          ' background-size: cover;' +
          ' background-position: center;' +
          ' background-attachment: scroll;'
      ]"
    >
      <div class="relative mt-auto z-10 bg-red-800/10 rounded-b-xl w-full bottom-0 left-0">
        <div class="text-sm font-semibold drop-shadow">
          <h3 class="h-3 text-lg text-gray-300 mb-5 mt-5">
            {{ props.user?.name ?? 'Nolly Sparking' }}
          </h3>
          <p class="text-gray-400 mb-5">
            {{ props.user?.profile?.location ?? 'Accra, Greater Accra, GH' }}
          </p>
        </div>
        <div class="text-sm mb-4 font-semibold drop-shadow flex flex-1 space-x-3 justify-around items-center text-gray-400">
          <span class="flex items-center">
            <BriefcaseIcon class="h-4 w-4 mr-1" />
            <span class="block">{{ props.user?.postCount }}</span>
          </span>
          <span class="flex items-center">
            <HeartIcon class="h-4 w-4 mr-1" />
            <span class="block">{{ props.user?.likeReceivedCount }}</span>
          </span>
          <span class="flex items-center">
            <UserGroupIcon class="h-4 w-4 mr-1" />
            <span class="block">{{ props.user?.followerCount }}</span>
          </span>
          <button
            v-if="useAuthStore().user?.id === props.creator?.id"
            id="follow-btn"
            data-user-id="{{ props.creator?.id }}"
            class="px-3 py-2 shadow-inner text-gray-400 text-xs  rounded-lg font-semibold transition-all duration-500"
            :class="{
              'bg-green-800/25 hover:bg-green-900/50' : !props.creator?.authenticatedUserIsFollowing,
              'bg-red-600/25 hover:bg-red-500/50' : props.creator?.authenticatedUserIsFollowing
            }"
            @click="toggleFollowing(props.creator?.id)"
          >
            <RssIcon class="h-3 w-3 inline mr-0.5" />
            <span v-if="!props.creator?.authenticatedUserIsFollowing">Follow</span>
            <span v-else>Unfollow</span>
          </button>
        </div>
      </div>
      <span class="absolute blur h-32 w-full bg-green-900/20 bottom-0 left-0 rounded-b-xl" />
    </div>
  </div>
</template>

<style scoped>
.blur {
  backdrop-filter: blur(1px);
  background: rgb(8, 58, 2,.3);
}
</style>
